module.exports = __webpack_public_path__ + "img/banner_introduce.90c05a96.jpg";